const WRONG_PASSWORD = '비밀번호를 확인해주세요.';

const EXCEL_DOWNLOAD_AUTH_EXPIRED =
    '엑셀 다운로드 2차 인증 상태가 만료되었습니다. 다시 2차 인증을 진행해 주세요.';

const EXCEL_DOWNLOAD_FAILED =
    'Excel 다운로드에 실패했습니다. 잠시 후 다시 시도해주세요.';

export {WRONG_PASSWORD, EXCEL_DOWNLOAD_AUTH_EXPIRED, EXCEL_DOWNLOAD_FAILED};
